import { render, staticRenderFns } from "./ProfitWithdrawal.vue?vue&type=template&id=1a06524a&scoped=true"
import script from "./ProfitWithdrawal.vue?vue&type=script&lang=js"
export * from "./ProfitWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./ProfitWithdrawal.vue?vue&type=style&index=0&id=1a06524a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a06524a",
  null
  
)

export default component.exports